import React, { useCallback, useEffect, useState } from 'react';
import { Slider } from '~/components/Slider';

import { useAutoSetCriteria } from '../../hooks/useAutoCriteria';
import { useAdvancedFiltersStore } from '../../store/useAdvancedFilterStore';
import { AgeInputFilter } from './AgeInputFilter';
import { FilterSection } from './FilterSection';
import { PLATFORM_OPTIONS } from './PlatformsToggle';
import { FILTERS } from './SearchByFollowers';
import { criterias, getRelevantCriteria } from './helpers';

export function AgeFilter() {
  const { activePlatform, setFilter, getFilter } = useAdvancedFiltersStore();

  const [previewValue, setPreviewValue] = useState({
    [PLATFORM_OPTIONS.selectPlatform]: criterias[0],
    [PLATFORM_OPTIONS.instagram]: criterias[0],
    [PLATFORM_OPTIONS.tiktok]: criterias[0],
    [PLATFORM_OPTIONS.youtube]: criterias[0],
    [PLATFORM_OPTIONS.snapchat]: criterias[0],
  });

  useAutoSetCriteria(FILTERS.ageCriteria, setPreviewValue);

  const ageValue = getFilter(activePlatform, FILTERS.ageCriteria) || 0;
  const selectedAge = getFilter(activePlatform, FILTERS.age);

  useEffect(() => {
    if (
      activePlatform !== 'snapchat' &&
      Number(ageValue) !== previewValue[activePlatform].value
    ) {
      const relevantMark = getRelevantCriteria(Number(ageValue));
      setPreviewValue({ ...previewValue, [activePlatform]: relevantMark });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ageValue, activePlatform, setPreviewValue]);

  const onChange = useCallback(
    (value: number) => {
      const relevantMark = getRelevantCriteria(value);

      setPreviewValue({
        ...previewValue,
        [activePlatform]: relevantMark,
      });
    },
    [setPreviewValue, activePlatform, previewValue],
  );

  const onChangeEnd = useCallback(
    (value: number) => {
      const relevantMark = getRelevantCriteria(value);

      setFilter(activePlatform, FILTERS.ageCriteria, relevantMark.value);
    },
    [activePlatform, setFilter],
  );

  return (
    <FilterSection title="Age">
      <AgeInputFilter />
      <Slider
        title="Select Age Criteria"
        label={previewValue[activePlatform].label}
        value={previewValue[activePlatform].value}
        marks={criterias}
        onChange={onChange}
        onChangeEnd={onChangeEnd}
        isDisabled={!selectedAge}
      />
    </FilterSection>
  );
}
